import React from "react"
import styled from "styled-components"

import { Container, Col } from "../../components/Grid"
import Testimonials from "./Testimonials"
import Button from "../Button"
import Snippet from "../Snippet"
import Link from "../Link"

import { media, mixins } from "../../styles"

const Wrapper = styled.div`
  background: var(--color-greyLight);
  padding: 30px 0;

  @media ${media.md} {
    padding: 45px 0;
  }

  @media ${media.lg} {
    padding: 60px 0;
  }

  @media ${media.xl} {
    padding: 100px 0 115px;
  }
`

const Header = styled.div`
  margin-bottom: 30px;
  text-align: center;

  @media ${media.md} {
    margin-bottom: 45px;
  }

  @media ${media.lg} {
    margin-bottom: 50px;
  }

  @media ${media.xl} {
    margin-bottom: 80px;
  }

  h3 {
    ${mixins.title3}
  }
`

const ButtonRow = styled.div`
  text-align: center;

  @media ${media.md} {
    margin: 40px 0 25px;
  }

  @media ${media.lg} {
    margin: 55px 0 0;
  }
`

const Partners = ({ testimonials }) => {
  return (
    <Container>
      <Wrapper>
        <Col md="8" mdOffset="2">
          <Header>
            <h3>
              <Snippet id="homePartners" field="header" />
            </h3>
          </Header>
        </Col>
        <Testimonials testimonials={testimonials} />

        <ButtonRow>
          <Button to={`/case-studies/`} as={Link} arrow>
            <Snippet id="homePartners" field="linkText" />
          </Button>
        </ButtonRow>
      </Wrapper>
    </Container>
  )
}

export default Partners
